import React from 'react'

const ViewerPanelBreadcrumbsContainer = ({ children }) => {
  return <div className="viewer-panel-breadcrumbs-nav">{children}</div>
}

export default ViewerPanelBreadcrumbsContainer
